export default __webpack_public_path__ + "static/media/logo1.03855935.png";